import { z } from 'zod';
import { apiGet } from '@/lib/api';

/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  KOPIA PORTALU — spis zawartości i adres pobrania.
 *
 *  ⚠️⚠️ SPIS OSOBNO OD PLIKU. Paczka niesie dane osobowe kadry klienta, więc nie powinna powstawać
 *  po to, żeby ktoś dowiedział się, co w niej jest. Ekran pyta o spis, pokazuje go, i dopiero
 *  wtedy człowiek decyduje.
 *
 *  ⚠️ SAM PLIK IDZIE ZWYKŁYM ODNOŚNIKIEM Z CIASTECZKIEM SESJI, nie przez `fetch`. Tak samo pobiera
 *  się kopie baz — przeciąganie kilku megabajtów przez pamięć przeglądarki po to, żeby zaraz zapisać
 *  je na dysk, nie daje niczego poza możliwością zawieszenia karty.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */
export const fetchSpisKopiiPortalu = (groupId: string) =>
  apiGet(
    `/kopia-portalu/spis?groupId=${encodeURIComponent(groupId)}`,
    z.object({
      wyspa: z.string(),
      pliki: z.array(z.object({ plik: z.string(), opis: z.string(), wierszy: z.number() })),
    }),
  );

export const KOPIA_PORTALU_POBIERZ = '/kopia-portalu/pobierz';
